/**
 * TV Session Mutation Hooks
 *
 * TanStack Query mutation hooks for the TV device-pairing handshake (/tv).
 */

import { useMutation } from '@tanstack/react-query';
import { tvClient } from '../client/tv.client';

export function useConfirmTvSession() {
  return useMutation({
    mutationFn: (code: string) => tvClient.confirm(code),
  });
}

export function useCancelTvSession() {
  return useMutation({
    mutationFn: (code: string) => tvClient.cancel(code),
  });
}
